<template>
  <div v-if="loadingFlag">
    <!-- <van-sticky @scroll="stickyChange" :class="stickyChangeFlag ? 'stickyBottom' : ''">
      <van-nav-bar title="订单详情" left-text="返回" left-arrow @click-left="onClickLeft"/>
    </van-sticky> -->
    <!-- <van-cell title="订单号" class="headerOrder" is-link arrow-direction="down" :value="$route.params.orderId" /> -->
    <van-cell title="订单号" class="headerOrder" is-link arrow-direction="down" :value="form.purNo" />
    <div class="box">
      <!-- 进度条 -->
      <van-steps :active="active">
        <van-step v-for="(item, index) in stepsOneList" :key="index">{{item}}</van-step>
      </van-steps>
      <!-- 物流单号 -->
      <div class="addressBox">
        <p>物流单号</p>
        <span class="wuliuCode">{{form.expressNo}}</span>
        <van-button class="addBtns" size="small" plain type="default" @click="copyCode">复制</van-button>
      </div>
      <!-- 套餐块 -->
      <div class="vIfBox" v-if="form.pkList">
        <div class="content" v-for="(item, index) in form.pkList.records" :key="index">
          <van-cell-group>
            <van-cell title="套餐名称" :value="item.pkName" />
            <van-cell title="单价" :value="item.unitPr | priceGet" />
            <van-cell title="数量" :value="item.quantity" />
            <van-cell title="下级分润" :value="item.profit | priceGet" v-if="item.profit"/>
            <van-cell title="金额" :value="item.amount | priceGet" />
          </van-cell-group>
        </div>
      </div>
      <div class="zwf"></div>
      <van-submit-bar :price="form.totalAmount * 100">
        <template #default>
          <p>物流费用：￥{{ form.delieveryFee }}</p>
        </template>
        <template #tip>
          <div class="addressBox">
            <p>收货地址:</p>
            <span class="wuliuCode">{{form.address}}</span>
          </div>
        </template>
      </van-submit-bar>
    </div>
  </div>
  <div v-else class="loadgin">
    <van-loading type="spinner" vertical>加载中...</van-loading>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import { Toast } from 'vant'
import { userOrder } from '@/api/orther.js'
export default {
  name: 'PurchaseXQ',
  components: {},
  props: {
  },
  data () {
    return {
      stickyChangeFlag: false,
      // 进度条展示位置
      active: 0,
      stepsOneList: ['已付款', '未发货', '送达'],
      // 收货地址
      ReceAddress: '',
      // 物流费用
      wlPrice: '',
      // 套餐列表
      list: [],
      // 最终价格需要乘上 100
      // 例如，最终价格是 30.50 ，allprice 应该写3050
      allPrice: 0,
      orderId: '',
      form: {},
      loadingFlag: true
    }
  },
  watch: {},
  computed: {},
  filters: {
    priceGet: function (value) {
      const price = value + ''
      if (price.length > 0 && price !== 'undefined') {
        return '￥' + value
      }
      return ''
    }
  },
  methods: {
    // onClickLeft () { this.$router.go(-1) },
    copyCode () {
      const clipboard = new Clipboard('.addBtns', {
        target: function () {
          return document.querySelector('.wuliuCode')
        }
      })
      clipboard.on('success', e => {
        Toast.success('复制成功')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 释放内存
        clipboard.destroy()
      })
    },
    stickyChange (e) {
      this.stickyChangeFlag = e.isFixed
    },
    async getOrderContent () {
      const { data: res } = await userOrder({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0], orderId: this.orderId })
      this.active = this.stepsOneList.indexOf(res.status)
      this.form = res
    }
  },
  beforeCreate () {},
  created () {
    this.loadingFlag = false
    this.orderId = this.$route.params.orderId
    if (typeof this.orderId !== 'string') {
      window.location.reload(true)
    } else {
      this.loadingFlag = true
      this.getOrderContent()
    }
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .box {
    padding: 45px;
    .content {
      border-radius: 15px;
      overflow: hidden;
      border-top: 5px solid #88888817;
      border-left: 5px solid #88888817;
      box-shadow: 5px 5px 5px -2px #888888;
      margin-bottom: 20px!important;
    }
  }
  .vanStepsTitles {
    margin-left: -30px;
    margin-top: -5px;
    /deep/.van-step__circle-container {
      display: none
    }
    /deep/.van-step__line {
      display: none;
    }
    /deep/.van-hairline {
      padding-bottom: 10px;
      padding-top: 0px;
    }
    /deep/.van-step__title {
      font-size: 20px!important;
    }
  }
  .shul {
    height: 150px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    /deep/.van-cell::after {
      border: none;
    }
    .btn2 {
      margin-right: 25px;
    }
    .iptNum {
      width: 150px;
      text-align: right;
    }
    border-bottom: 1px solid #f5f6f7;
    margin-bottom: 15px;
  }
  .addressBox {
    display: flex;
    justify-content: space-around;
    padding: 15px;
    align-items: center;
    border-bottom: 1px solid #f5f6f7;
    font-size: 25px;
    .van-cell {
      padding: 0;
      /deep/.van-field__label {
        flex: 1;
      }
      /deep/.van-cell__value {
        flex: 3;
      }
    }
    p {
      width: 150px;
      color: #323233;
    }
    span {
      flex: 2;
    }
    .addBtns {
      margin-left: 15px;
    }
  }
  .zwf {
    height: 150px;
  }
  /deep/.van-submit-bar{
    .van-submit-bar__tip {
      .addressBox {
        padding: 0;
        border: none;
      }
    }
    .van-submit-bar__bar {
      .van-button {
        display: none;
      }
    }
  }
  .stickyBottom {
    /deep/.van-sticky {
      border-bottom: 1px solid #f3f3f3;
    }
  }
  [class*=van-hairline]::after {
    border: none;
  }
  .loadgin {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
